/**
 * Remove slashes from the start and end of a string
 * @param {string} str
 * @return {string}
 */
function stripSlashes(str) {
	return str.replace(/(^\/+|\/+$)/g, '');
}
export default href => {
	[...document.querySelectorAll('nav a[href^="#"]')].forEach(link => {
		link.classList.remove('is-current');
	});

	const activeLink = document.querySelector(`nav a[href="${href}"]`);
	if (activeLink) {
		activeLink.classList.add('is-current');
	}
};

export const setActiveAnchorLink = href => {
	[...document.querySelectorAll('a[href^="#"]')].forEach(link => {
		link.classList.remove('is-current');
	});

	const activeLink = document.querySelector(`a[href="${href}"]`);
	if (activeLink) {
		activeLink.classList.add('is-current');

		const linkParentLi = activeLink.closest('[data-primary]');
		if (linkParentLi) {
			const linkParent = linkParentLi.querySelector('[data-parent]');
			if (linkParent) {
				linkParent.classList.add('is-current');
			}
		}
	}
};

export const initScrollActiveLinks = () => {
	const navLinks = document.querySelectorAll('nav a[href^="#"]');
	const sections = Array.from(navLinks)
		.map(link => {
			const href = link.getAttribute('href');
			const section = document.querySelector(href);
			return { link, section, href };
		})
		.filter(item => item.section);

	if (sections.length === 0) return;

	const homeLink = navLinks[0]; // First nav link should be home
	let currentActive = homeLink ? homeLink.getAttribute('href') : null;

	if (homeLink) {
		setTimeout(() => {
			setActiveAnchorLink(currentActive);
		}, 50);
	}

	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const href = `#${entry.target.id}`;
					currentActive = href;
					setActiveAnchorLink(href);
				}
			});
		},
		{
			rootMargin: '-20% 0px -70% 0px',
			threshold: 0,
		}
	);

	const handleScroll = () => {
		if (window.scrollY < 100) {
			const firstLink = navLinks[0];
			if (firstLink) {
				const firstHref = firstLink.getAttribute('href');
				if (currentActive !== firstHref) {
					currentActive = firstHref;
					setActiveAnchorLink(firstHref);
				}
			}
		}
	};

	sections.forEach(({ section }) => {
		observer.observe(section);
	});

	window.addEventListener('scroll', handleScroll);

	return () => {
		sections.forEach(({ section }) => {
			observer.unobserve(section);
		});
		window.removeEventListener('scroll', handleScroll);
	};
};
